import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CardDesignerCardElementPlaceholder from '../CardDesignerCardElementPlaceholder';
import PhotoSlotIcon from '../../../../../icons/PhotoSlotIcon';
import { PHOTO_TYPE } from '../../../../../../services/cards/constants';
import LogoIcon from '../../../../../icons/LogoIcon';
import Badge from '../../../../Badge';

const propTypes = {
  element: PropTypes.shape({
    id: PropTypes.string,
    cardElement: PropTypes.shape({
      frame: PropTypes.shape({
        width: PropTypes.number,
        height: PropTypes.number,
      }),
    }),
    cardElementConfiguration: PropTypes.shape({
      asset_image: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
  }),
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  cardBounds: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  helperText: PropTypes.node,
};

const CardDesignerCardElementPhoto = ({
  element,
  className,
  onClick,
  cardBounds,
  helperText,
}) => {
  const { cardElement, cardElementConfiguration } = element;
  const { help_placeholder: helpPlaceholder } = cardElementConfiguration ?? {};
  const { asset_image: assetImage, photo_type: photoType } =
    cardElementConfiguration ?? {};
  const classes = classNames({
    'card-designer-card-element': true,
    'card-designer-card-element-photo': true,
    [className]: !!className,
  });

  const Icon = useMemo(() => {
    if (photoType === PHOTO_TYPE.LOGO) {
      return <LogoIcon color="#798588" />;
    }

    return <PhotoSlotIcon />;
  }, [photoType]);

  const frame = cardElement?.frame;
  const minWidth =
    frame && cardBounds?.width
      ? Math.floor(frame.width * cardBounds.width * 300)
      : null;
  const minHeight =
    frame && cardBounds?.height
      ? Math.floor(frame.height * cardBounds.height * 300)
      : null;

  return (
    <a
      href="#"
      className={classes}
      onClick={event => {
        event.preventDefault();
        onClick();
      }}
    >
      {!assetImage && (
        <CardDesignerCardElementPlaceholder
          icon={
            <div className="d-flex flex-column align-items-center text-light text-xs">
              {Icon}
              {!helperText && minWidth && minHeight && (
                <div className="mt-1 text-center px-2">
                  Minimum suggested resolution:
                  <br />
                  {minWidth}px x {minHeight}px
                </div>
              )}
            </div>
          }
          helperText={helperText}
          iconClassName="card-designer-card-element-photo-icon"
        />
      )}
      {!!helpPlaceholder && (
        <Badge badgeSize="xs" badgeStyle="info">
          {helpPlaceholder}
        </Badge>
      )}
    </a>
  );
};

CardDesignerCardElementPhoto.propTypes = propTypes;

export default CardDesignerCardElementPhoto;
